<template>
    <div>
        <div class="layout">
            <div class="title-select-wrap">
            </div>
            <ul class="tab-btn-list align-start">
                <li :class="{on: commonTabs === 0}"><a href="#/" class="tab" @click="saveStat(0)">1. 통계표 선택</a></li>
                <li :class="{on: commonTabs === 1}"><a href="#/" class="tab" @click="saveStat(1)">2. 항목 선택</a></li>
                <li :class="{on: commonTabs === 2}"><a href="#/" class="tab" @click="saveStat(2)">3. 연도 선택</a></li>
                <li :class="{on: commonTabs === 3}"><a href="#/" class="tab" @click="saveStat(3)">4. 통계 조회</a></li>
            </ul>
            <div class="stat-type-wrap">
                <div class="stat-type-head align-end type02">

                </div>
                <div class="stat-type-header" v-show="commonTabs !== 3">
                    <h3>선택 통계표</h3>
                    <div class="align-start stat-type-header__inner">
                        <button type="button" class="default btn" v-show="commonTabs === 0 || commonTabs === 1" @click="resetStorage()">초기화</button>
                        <button type="button" class="default btn" v-show="commonTabs === 0" @click="saveStatStorage()">저장</button>
                        <button type="button" class="default btn" v-show="commonTabs === 1" @click="saveCellStorage()">저장</button>
                        <button type="button" class="default btn" v-show="commonTabs === 2" @click="selectMultiStblList()">통계표 조회</button>
                    </div>
                </div>
                <div class="stat-type-content border" v-show="commonTabs === 0 || commonTabs === 1">
                    <div class="mdss-table-wrap type02">
                        <table class="mdss-table type02">
                            <colgroup>
                                <col style="width:292px;">
                                <col>
                                <col style="width:238px;">
                                <col style="width:120px;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" style="width:292px;">분류</th>
                                    <th scope="col">통계표명</th>
                                    <th scope="col" style="width: 238px;" colspan="2">입력연도</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, idx) in selectedStaticList" v-bind:key="idx">
                                    <td data-th=""><span class="badge mrr10">{{ data.categoryNm }}</span>{{ data.statNm }}</td>
                                    <td data-th="통계표명"><span :class="{selSpan : commonTabs === 1, on : selectedCellStatic === data.tblMgmNo }" @click.prevent="selectCellList(data.tblMgmNo, idx)">{{ data.tblKorNm }}</span></td>
                                    <td data-th="입력연도">{{ data.tblYearMonth }}</td>
                                    <td class="mob-th-none">
                                        <button type="button" class="tbl-btn" @click="removeStat(data)" v-show="commonTabs === 0">삭제</button>
                                        <button type="button" class="tbl-btn cursor-no" v-show="commonTabs === 1 && (data.selectedCellHeaderList.length == 0 || data.selectedCellLeftList.length == 0)">항목 미설정</button>
                                        <button type="button" class="tbl-btn-fin cursor-no" v-show="commonTabs === 1 && data.selectedCellHeaderList.length > 0 && data.selectedCellLeftList.length > 0">설정완료</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- 통계표 조회 선택 통계표 -->
                <div class="stat-type-header" v-show="commonTabs === 3">
                    <h3>선택 통계표</h3>
                    <div class="align-start stat-type-header__inner">
                        <span class="selSpan hideStaticsBtn" :class="{close : btnOpen}" v-show="commonTabs === 3" @click="closeSelectedStatics($event)"><img :src=btnOpClImg alt="선택통계표열고닫기"></span>
                    </div>
                </div>
                <div class="stat-type-content border hideStatics" v-show="commonTabs === 3">
                    <div class="mdss-table-wrap type02">
                        <table class="mdss-table type02">
                            <colgroup>
                                <col style="width:292px;">
                                <col>
                                <col style="width:238px;">
                                <col>
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" style="width:292px;">분류</th>
                                    <th scope="col">통계표명</th>
                                    <th scope="col" style="width: 238px;" colspan="2">입력연도</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, idx) in selectedStaticList" v-bind:key="idx">
                                    <td><span class="badge mrr10">{{ data.categoryNm }}</span>{{ data.statNm }}</td>
                                    <td data-th="통계표명"><span>{{ data.tblKorNm }}</span></td>
                                    <td data-th="입력연도">{{ data.tblYearMonth }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- 연도 선택 -->
                <div class="stat-type-content align-start top border" v-show="commonTabs === 2">
                    <div class="mdss-table-wrap">
                        <table class="mdss-table type02">
                            <colgroup>
                                <col>
                                <col style="width:292px;">
                                <col style="width: 238px;">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" style="width:292px;">분류</th>
                                    <th scope="col">통계표명</th>
                                    <th scope="col" style="width: 238px;">입력연도</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, idx) in selectedStaticList" v-bind:key="idx">
                                    <td data-th=""><span class="badge mrr10">{{ data.categoryNm }}</span>{{ data.statNm }}</td>
                                    <td data-th="통계표명"><span :class="{selSpan : commonTabs === 1, on : selectedCellStatic === data.tblMgmNo }" @click.prevent="selectCellList(data.tblMgmNo, idx)">{{ data.tblKorNm }}</span></td>
                                    <td data-th="입력연도">{{ data.tblYearMonth }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="year-table">
                        <h3 class="on">연도선택</h3> <!-- 모바일에서는 h3태그에 class="on"이 있어야 연도선택리스트가 나옵니다. -->
                        <ul>
                            <li class="tbl-checkbox-box">
                                <input type="checkbox" id="all_year" v-model="allChecked" @click="checkedAllYearList($event.target.checked)">
                                <i></i>
                                <label for="all_year">전체</label>
                            </li>
                            <li class="tbl-checkbox-box" v-for="(data, idx) in tblYearList" v-bind:key="idx">
                                <input type="checkbox" :id="data.tblYearMonth" v-model="data.selected" @change="selectedYearList($event)">
                                <i></i>
                                <label :for="data.tblYearMonth">{{ data.tblYearMonth }}</label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="stat-type-wrap mrt20">
                <!-- 통계표 선택 -->
                <div v-show="commonTabs === 0">
                    <div class="stat-type-header">
                        <h3>통계표 선택</h3>
                        <div class="stat-type-header__inner">
                            <div class="stat-search-box2">
                                <!-- <input type="search"> -->
                                <input type="search" id="tblKorNmString" v-model="tblKorNmString" v-on:keyup.enter="searchStaticList(true)">
                                <button type="submit" @click="searchStaticList(true)">검색</button>
                            </div>
                        </div>
                    </div>
                    <!-- 통계표 검색 -->
                    <div class="stat-type-list type03" v-show="searchGubun">
                        <div class="search--list__counter">
                            <p>검색 결과는 총 <em>{{ searchStaticDetailCnt }}</em>건 입니다.</p>
                            <button type="button" @click="closeSearch()"><img src="../../assets/img/popup_close.png" alt="닫기"></button>
                        </div>
                        <ul class="search--list__result">
                           <li v-for="(data, idx) in searchStaticDetailList" v-bind:key="idx">
                                <a href="javascript:;" @click.prevent="searchDepthStatistics(data.tblMgmNo, '', 'N', 0, data.tblKorNm, data.tblYearMonth, data.upPath)">
                                    <p>{{ data.tblKorNm }}</p>
                                    <span>{{ data.upPathNm }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <ul class="stat-type-list align-start type02" v-show="!searchGubun">
                        <li class="intro">
                            <ul class="stat-depth02">
                                <li :class="{on : selectedDepthMenu === 'STBL-1014250'}"><a href="#/" @click.prevent="selectMenu('STBL-1014250', '문화')">문화</a></li>
                                <li :class="{on : selectedDepthMenu === 'STBL-1030638'}"><a href="#/" @click.prevent="selectMenu('STBL-1030638', '예술')">예술</a></li>
                                <li :class="{on : selectedDepthMenu === 'STBL-1014252'}"><a href="#/" @click.prevent="selectMenu('STBL-1014252', '콘텐츠')">콘텐츠</a></li>
                                <li :class="{on : selectedDepthMenu === 'STBL-1014253'}"><a href="#/" @click.prevent="selectMenu('STBL-1014253', '관광')">관광</a></li>
                                <li :class="{on : selectedDepthMenu === 'STBL-1014255'}"><a href="#/" @click.prevent="selectMenu('STBL-1014255', '스포츠')">스포츠</a></li>
                                <li :class="{on : selectedDepthMenu === 'STBL-1030639'}"><a href="#/" @click.prevent="selectMenu('STBL-1030639', '종합')">종합</a></li>
                            </ul>
                        </li>
                        <li :class="{lastDepth01: depthClass == 1}">
                            <ul class="stat-depth02">
                                <li v-for="(data, idx) in multiStblDepth01List" v-bind:key="idx" :class="{on : selected1DepthMenu === data.menuId, result: data.lowerLevelYn === null}">
                                    <a href="#" @click.prevent="searchDepthStatistics(data.menuId, data.uppermenuId, data.lowerLevelYn, 1, data.title, data.tblYearMonth)">{{ data.title }}</a>
                                </li>
                            </ul>
                        </li>
                        <li v-show="depth2Yn" :class="{lastDepth02: depthClass == 2}">
                            <ul class="stat-depth02">
                                <li v-for="(data, idx) in static2depthListData" v-bind:key="idx" :class="{on : selected2DepthMenu === data.menuId, result: data.lowerLevelYn === null}" >
                                    <a href="#" @click.prevent="searchDepthStatistics(data.menuId, data.uppermenuId, data.lowerLevelYn, 2, data.title, data.tblYearMonth)">{{ data.title }}</a>
                                </li>
                            </ul>
                        </li>
                        <li v-show="depth3Yn" :class="{lastDepth03: depthClass == 3}">
                            <ul class="stat-depth02">
                                <li v-for="(data, idx) in static3depthListData" v-bind:key="idx" :class="{on : selected3DepthMenu === data.menuId, result: data.lowerLevelYn === null}" >
                                    <a href="#" @click.prevent="searchDepthStatistics(data.menuId, data.uppermenuId, data.lowerLevelYn, 3, data.title, data.tblYearMonth)">{{ data.title }}</a>
                                </li>
                            </ul>
                        </li>
                        <li v-show="depth4Yn" :class="{lastDepth04: depthClass == 4}">
                            <ul class="stat-depth02">
                                <li v-for="(data, idx) in static4depthListData" v-bind:key="idx" :class="{on : selected4DepthMenu === data.menuId, result: data.lowerLevelYn === null}">
                                    <a href="#" @click.prevent="searchDepthStatistics(data.menuId, data.uppermenuId, data.lowerLevelYn, 4, data.title, data.tblYearMonth)">{{ data.title }}</a>
                                </li>
                            </ul>
                        </li>
                        <li v-show="depth5Yn" :class="{lastDepth05: depthClass == 5}">
                            <ul class="stat-depth02">
                                <li v-for="(data, idx) in static5depthListData" v-bind:key="idx" :class="{on : selected5DepthMenu === data.menuId, result: data.lowerLevelYn === null}">
                                    <a href="#" @click.prevent="searchDepthStatistics(data.menuId, data.uppermenuId, data.lowerLevelYn, 5, data.title, data.tblYearMonth)">{{ data.title }}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <!-- 항목 선택 -->
                <div v-show="commonTabs === 1">
                    <div class="stat-type-header">
                        <h3>항목 선택</h3>
                    </div>
                    <div class="stat-type-list type03" v-for="(stat, index) in selectedStaticList" v-bind:key="index" v-show="selectedCellStatic === stat.tblMgmNo">
                        <div class="align-start align-wrap-full checkbox-wrapper">
                            <div class="checkbox-form">
                                <h4>표두 항목</h4>
                                <ul>
                                    <li class="tbl-checkbox-box pdl0" v-for="(data, idx) in stat.statHeader" v-bind:key="idx">
                                        <!-- <input type="checkbox" :id="data.tblMgmNo+'_header_'+idx" :value="data.nodeKey" @click="selectCellHeader(data.nodeKey, idx, data.pathNm, data.pathNodeKey)">
                                        <i></i> -->
                                        <label :for="data.tblMgmNo+'_header_'+idx" class="cusor-pointer" @click="selectCellHeader(data.nodeKey, idx, data.pathNm, data.pathNodeKey)">{{ data.pathNm }}</label>
                                    </li>
                                </ul>
                            </div>
                            <div class="arrow-btn-wrap">
                                <button type="button" class="nnext" @click.prevent="saveCellHeader('all_plus', stat.tblMgmNo)"><img src="../../assets/img/arrow-nnext.png" alt="전체선택"></button>
                                <button type="button" class="pprev" @click="saveCellHeader('all_minus', stat.tblMgmNo)"><img src="../../assets/img/arrow-pprev.png" alt="전체제거"></button>
                            </div>
                            <div class="checkbox-form">
                                <h4>선택 표두 항목</h4>
                                <ul>
                                    <li class="tbl-checkbox-box pdl0" v-for="(data, idx) in stat.selectedCellHeaderList" v-bind:key="idx">
                                        <!-- <input type="checkbox" :id="data.tblMgmNo+'_header_'+idx" :value="data.nodeKey" @click="selectCellHeader(data.nodeKey, idx, data.pathNm, data.pathNodeKey)">
                                        <i></i> -->
                                        <label :for="data.tblMgmNo+'_header_'+idx" class="cusor-pointer" @click="selectCellHeader(data.nodeKey, idx, data.pathNm, data.pathNodeKey)">{{ data.pathNm }}</label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="align-start align-wrap-full checkbox-wrapper">
                            <div class="checkbox-form">
                                <h4>표측 항목</h4>
                                <ul>
                                    <li class="tbl-checkbox-box pdl0" v-for="(data, idx) in stat.statLeft" v-bind:key="idx">
                                        <!-- <input type="checkbox" :id="data.tblMgmNo+'_left_'+idx" :value="data.nodeKey" @click="selectCellLeft(data.nodeKey, idx, data.pathNm, data.pathNodeKey)">
                                        <i></i> -->
                                        <label :for="data.tblMgmNo+'_left_'+idx" class="cusor-pointer" @click="selectCellLeft(data.nodeKey, idx, data.pathNm, data.pathNodeKey)">{{ data.pathNm }}</label>
                                    </li>
                                </ul>
                            </div>
                            <div class="arrow-btn-wrap">
                                <button type="button" class="nnext" @click.prevent="saveCellLeft('all_plus', stat.tblMgmNo)"><img src="../../assets/img/arrow-nnext.png" alt="전체선택"></button>
                                <button type="button" class="pprev" @click.prevent="saveCellLeft('all_minus', stat.tblMgmNo)"><img src="../../assets/img/arrow-pprev.png" alt="전체제거"></button>
                            </div>
                            <div class="checkbox-form">
                                <h4>선택 표측 항목</h4>
                                <ul>
                                    <li class="tbl-checkbox-box pdl0" v-for="(data, idx) in stat.selectedCellLeftList" v-bind:key="idx">
                                        <label :for="data.tblMgmNo+'_left_'+idx" class="cusor-pointer" @click="selectCellLeft(data.nodeKey, idx, data.pathNm, data.pathNodeKey)">{{ data.pathNm }}</label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 통계표 조회 -->
                <div v-show="commonTabs === 3">
                    <div class="stat-type-header">
                        <h3>통계표</h3>
                        <div class="stat-type-header__inner">
                            <div class="stat-search-box2">
                                <button type="submit" @click="gridDownload()">다운로드</button>
                            </div>
                        </div>
                    </div>
                    <div class="stat-type-content border">
                        <div class="mdss-table-wrap type02" style="overflow: auto;width:100%;height:600px;">
                            <table class="mdss-table type02 infinitude multi-grid" style="table-layout: fixed;width: 1500px;" id="multiGrid">
                                <colgroup>
                                    <col :style="col1Width">
                                    <col :style="col2Width" v-if="!headHide1">
                                    <col :style="col2Width" v-if="!headHide2">
                                    <col :style="col2Width" v-if="!headHide3">
                                    <col :style="col2Width" v-if="!leftHide1">
                                    <col :style="col2Width" v-if="!leftHide2">
                                    <col :style="col2Width" v-if="!leftHide3">
                                    <col v-for="(data, idx) in gridYear" v-bind:key="idx" style="width:150px;">
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th scope="col" :style="col1Width">통계표명</th>
                                        <th scope="col" :style="col2Width" v-if="!headHide1">표두1</th>
                                        <th scope="col" :style="col2Width" v-if="!headHide2">표두2</th>
                                        <th scope="col" :style="col2Width" v-if="!headHide3">표두3</th>
                                        <th scope="col" :style="col2Width" v-if="!leftHide1">표측1</th>
                                        <th scope="col" :style="col2Width" v-if="!leftHide2">표측2</th>
                                        <th scope="col" :style="col2Width" v-if="!leftHide3">표측3</th>
                                        <th scope="col" v-for="(data, idx) in gridYear" v-bind:key="idx">{{ data }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, idx) in rowData" v-bind:key="idx">
                                        <td data-th="통계표명"><span v-if="idx === 0 || data.tblKorNm !== rowData[idx - 1].tblKorNm">{{ data.tblKorNm }}</span></td>
                                        <td data-th="표두1" v-if="!headHide1"><span v-if="idx === 0 || data.cellHead1 !== rowData[idx - 1].cellHead1">{{ data.cellHead1 }}</span></td>
                                        <td data-th="표두2" v-if="!headHide2"><span v-if="idx === 0 || data.cellHead2 !== rowData[idx - 1].cellHead2">{{ data.cellHead2 }}</span></td>
                                        <td data-th="표두3" v-if="!headHide3"><span v-if="idx === 0 || data.cellHead3 !== rowData[idx - 1].cellHead3">{{ data.cellHead3 }}</span></td>
                                        <td data-th="표측1" v-if="!leftHide1"><span v-if="idx === 0 || data.cellLeft1 !== rowData[idx - 1].cellLeft1">{{ data.cellLeft1 }}</span></td>
                                        <td data-th="표측2" v-if="!leftHide2"><span v-if="idx === 0 || data.cellLeft2 !== rowData[idx - 1].cellLeft2">{{ data.cellLeft2 }}</span></td>
                                        <td data-th="표측3" v-if="!leftHide3"><span v-if="idx === 0 || data.cellLeft3 !== rowData[idx - 1].cellLeft3">{{ data.cellLeft3 }}</span></td>
                                        <td class="text-align-center" :data-th="'데이터 '+i" v-for="(item, i) in gridYear" v-bind:key="i">{{ data[`${item}`] | visitComma}}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import store from '@/store/index'
import * as api from '@/api/MultiStbl.js'
import * as staticApi from '@/api/Statistics.js'
import * as locale from '@/api/common/locale.js'
import * as xlsx from 'xlsx'

export default {
	name: 'MultiStbl',

	components: {

	},

	data () {
		return {
			commonTabs: 0,
			depthClass: 0,
			multiStblDepth01List: [],
			statisticsListData: [],
			depth2Yn: false,
			depth3Yn: false,
			depth4Yn: false,
			depth5Yn: false,
			selectedDepthMenu: 'STBL-1014250',
			selected1DepthMenu: '',
			selected2DepthMenu: '',
			selected3DepthMenu: '',
			selected4DepthMenu: '',
			selected5DepthMenu: '',
			static2depthListData: [],
			static3depthListData: [],
			static4depthListData: [],
			static5depthListData: [],
			tblKorNmString: '',
			searchStaticDetailList: [],
			searchStaticDetailCnt: 0,
			// 1.통계표 선택
			selectedStaticList: [], // 선택 통계표 목록
			categoryNm: '문화', // 1depth 분류명
			statNm: '', // 2depth 분류명
			// 2.항목선택
			selectedCellStatic: '', // 선택된 통계표
			checkCellHeader: [],
			checkCellLeft: [],
			cellheaderList: [],
			cellLeftList: [],
			tblYearList: [],
			tblYearMonthList: [],
			allChecked: false,
			searchGubun: false,
			btnOpen: false,
			col1Width: 'width:292px;',
			col2Width: 'width:200px;',
			fixWidth: 'width:1500px;',
			btnOpClImg: require('../../assets/img/ico_select_arrow2.png'),
			// 로컬스토리지 설정
			storageStatList: store.state.storageStatInfo,
			// 그리드html설정
			headHide1: false,
			headHide2: false,
			headHide3: false,
			leftHide1: false,
			leftHide2: false,
			leftHide3: false,
			gridYear: [],
			gridColumn: [],
			// 그리드 엑셀다운로드 설정
			visibleHeadProps: [],
			instance: undefined,
			rowData: [],
			columnDefs: []

		}
	},

	filters: {
		visitComma: function (value) {
			var num
			if (value != null) {
				num = String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
			} else {
				num = ''
			}
			return num
		}
	},

	mounted () {

	},

	created () {
		window.addEventListener('resize', this.eventWidthResize)
		this.initStatisticList('STBL-1014250')
	},

	methods: {
		eventWidthResize () {
			if (window.innerWidth < 1200) {
				this.col1Width = 'width:190px;'
				this.col2Width = 'width:160px;'
				this.fixWidth = 'width:1200px;'
			} else {
				this.col1Width = 'width:292px;'
				this.col2Width = 'width:200px;'
				this.fixWidth = 'width:1500px;'
			}
		},
		async initStatisticList (upTblMgmNo) {
			const paramData = {
				upTblMgmNo: upTblMgmNo
			}

			const selectMultiStblDepthData = await api.selectMultiStblDepthList(paramData)
			this.multiStblDepth01List = selectMultiStblDepthData.data

			this.depthClass = 1
			this.depth2Yn = false
			this.depth3Yn = false
			this.depth4Yn = false
			this.depth5Yn = false

			if (this.storageStatList.length > 0) {
				this.selectedStaticList = this.storageStatList
			}
		},

		selectMenu (menuId, menuNm) {
			this.selectedDepthMenu = menuId
			this.categoryNm = menuNm

			this.initStatisticList(menuId)
		},

		// 로컬스토리지 및 선택통계표 초기화
		resetStorage () {
			store.commit('storageStatInfo', [])
			this.selectedStaticList = []
		},

		// 로컬스토리지 저장 - 통계표선택
		saveStatStorage () {
			if (this.validSelectedStatics()) {
				store.commit('storageStatInfo', this.selectedStaticList)
				alert('저장되었습니다.')
			}
		},

		// 로컬스토리지 저장 - 항목 선택
		saveCellStorage () {
			store.commit('storageStatInfo', this.selectedStaticList)
			alert('저장되었습니다.')
		},

		validSelectedStatics () {
			if (this.selectedStaticList.length === 0) {
				alert('통계표를 선택해주세요.')
				return false
			} else if (this.selectedStaticList.length === 1) {
				alert('통계표를 2개 이상 선택해주세요.')
				return false
			} else if (this.selectedStaticList.length > 5) {
				alert('통계표는 5개까지 선택할 수 있습니다.')
				return false
			} else {
				return true
			}
		},

		validSelectedCell () {
			let cellCnt = 0
			this.selectedStaticList.forEach((obj, idx) => {
				if (obj.selectedCellHeaderList.length === 0 || obj.selectedCellLeftList.length === 0) {
					cellCnt++
				}
			})

			if (cellCnt > 0) {
				alert('항목 선택을 완료해주세요.')
				return false
			} else {
				return true
			}
		},

		async saveStat (idx) {
			if (idx === 0) { // 통계표 선택 클릭 시
				this.commonTabs = idx
			} else if (idx === 1) { // 항목 선택 클릭 시
				if (this.validSelectedStatics()) {
					// console.log(this.selectedStaticList[0].tblMgmNo)
					this.commonTabs = idx
					this.selectCellList(this.selectedStaticList[0].tblMgmNo) // 선택통계표 클릭 이벤트
				}
			} else if (idx === 2) { // 연도 선택 클릭 시 tblYearMonth 세팅
				// 클릭할 때 새로 연도 세팅되는 거 수정 필요
				// 선택한 연도 표시되게 수정
				if (this.validSelectedStatics()) {
					if (this.validSelectedCell()) {
						// console.log(this.tblYearList)
						let yearString = ''

						this.selectedStaticList.forEach((obj, idx) => {
							if (idx == 0) yearString += obj.tblMgmNo
							else yearString += ',' + obj.tblMgmNo
						})

						const paramData = {
							multiGubun: yearString
						}

						const tblYearList = await api.selectMultiStblYear(paramData)
						this.tblYearList = tblYearList.data

						this.allChecked = false

						this.commonTabs = idx
					}
				}
			} else if (idx === 3) { // 통계 조회 클릭 시
				if (this.validSelectedStatics()) {
					if (this.validSelectedCell()) {
						this.selectMultiStblList()
					}
				}
			}
		},

		// 선택 통계표 열고닫기
		closeSelectedStatics (event) {
			if ($('.hideStaticsBtn').hasClass('close')) {
				$('.hideStaticsBtn').removeClass('close')
				this.btnOpClImg = require('../../assets/img/ico_select_arrow2.png')
				$('.hideStatics').stop().slideDown(500)
			} else {
				$('.hideStaticsBtn').addClass('close')
				this.btnOpClImg = require('../../assets/img/ico_select_arrow2_close.png')
				$('.hideStatics').stop().slideUp(300)
			}
		},

		// 통계표 클릭시
		async searchDepthStatistics (menuId, uppermenuId, lowerLevelYn, depth, title, tblYearMonth, upPath) {
			const paramData = {
				tblMgmNo: menuId
			}

			if (depth == 1 && lowerLevelYn == 'Y') { // 1depth이고 하위메뉴 있을 때
				const statisticsData = await staticApi.statisticsList(paramData)
				this.static2depthListData = statisticsData.data

				this.depthClass = 0
				if (this.static2depthListData.length > 0) {
					for (let i = 0; i < this.static2depthListData.length; i++) {
						if (this.static2depthListData[i].lowerLevelYn === null) this.depthClass = 2
					}
				}
				this.statNm = title
				this.selected1DepthMenu = menuId
				this.selected2DepthMenu = ''
				this.selected3DepthMenu = ''
				this.selected4DepthMenu = ''
				this.selected5DepthMenu = ''
				this.depth2Yn = true
				this.depth3Yn = false
				this.depth4Yn = false
				this.depth5Yn = false
			} else if (depth == 2 && lowerLevelYn == 'Y') { // 2depth이고 하위메뉴 있을 때
				const statisticsData = await staticApi.statisticsList(paramData)
				this.static3depthListData = statisticsData.data
				this.depthClass = 0
				if (this.static3depthListData.length > 0) {
					for (let i = 0; i < this.static3depthListData.length; i++) {
						if (this.static3depthListData[i].lowerLevelYn === null) this.depthClass = 3
					}
				}
				this.selected2DepthMenu = menuId
				this.selected3DepthMenu = ''
				this.selected4DepthMenu = ''
				this.selected5DepthMenu = ''
				this.depth3Yn = true
				this.depth4Yn = false
				this.depth5Yn = false
			} else if (depth == 3 && lowerLevelYn == 'Y') { // 3depth이고 하위메뉴 있을 때
				const statisticsData = await staticApi.statisticsList(paramData)
				this.static4depthListData = statisticsData.data
				this.depthClass = 0
				if (this.static4depthListData.length > 0) {
					for (let i = 0; i < this.static4depthListData.length; i++) {
						if (this.static4depthListData[i].lowerLevelYn === null) this.depthClass = 4
					}
				}
				this.selected3DepthMenu = menuId
				this.selected4DepthMenu = ''
				this.selected5DepthMenu = ''
				this.depth4Yn = true
				this.depth5Yn = false
			} else if (depth == 4 && lowerLevelYn == 'Y') { // 4depth이고 하위메뉴 있을 때
				const statisticsData = await staticApi.statisticsList(paramData)
				this.static5depthListData = statisticsData.data
				this.depthClass = 0
				if (this.static5depthListData.length > 0) {
					for (let i = 0; i < this.static5depthListData.length; i++) {
						if (this.static5depthListData[i].lowerLevelYn === null) this.depthClass = 5
					}
				}
				this.selected4DepthMenu = menuId
				this.selected5DepthMenu = ''
				this.depth5Yn = true
			}

			// 통계표 상세보기
			if (lowerLevelYn == 'N' || lowerLevelYn == null) { // 마지막 depth일 때
				let haveStat = false // 선택 통계표가 존재하는지 확인

				for (const stat of this.selectedStaticList) {
					if (stat.tblMgmNo === menuId) {
						haveStat = true
						break
					}
				}

				// 선택 통계표 목록 생성
				if (!haveStat) {
					let selectStatNm
					let selectCategoryNm

					if (depth == 0) { // 통계 검색에서 클릭한 경우
						const selectPath = upPath.substr(0, upPath.indexOf('>>'))
						selectCategoryNm = selectPath

						const upPathString = upPath.substr(upPath.indexOf('>>') + 2)
						const secondIdx = upPathString.indexOf('>>')
						selectStatNm = upPathString.substr(0, secondIdx)
					} else {
						selectStatNm = this.statNm
						selectCategoryNm = this.categoryNm
					}

					const statParam = {
						categoryNm: selectCategoryNm,
						statNm: selectStatNm,
						tblKorNm: title,
						tblMgmNo: menuId,
						tblYearMonth: tblYearMonth,
						cellheaderList: [],
						cellLeftList: [],
						selectedCellHeaderList: [],
						selectedCellLeftList: [],
						statHeader: [],
						statLeft: []
					}

					if (this.selectedStaticList.length > 4) {
						alert('통계표는 5개까지 선택할 수 있습니다.')
						return false
					}

					this.$set(this.selectedStaticList, this.selectedStaticList.length, statParam)
				}

				if (depth == 1) this.selected1DepthMenu = menuId
				else if (depth === 2) this.selected2DepthMenu = menuId
				else if (depth === 3) this.selected3DepthMenu = menuId
				else if (depth === 4) this.selected4DepthMenu = menuId
			}
		},

		// 선택 통계표 목록 삭제
		removeStat (data) {
			this.selectedStaticList.forEach((item, idx) => {
				if (item.tblMgmNo === data.tblMgmNo) {
					this.$delete(this.selectedStaticList, idx)
				}
			})
		},

		// 통계표 검색
		async searchStaticList (gubun) {
			if (this.tblKorNmString === '' || this.tblKorNmString === null) {
				alert('검색어를 입력해주세요.')
				return
			}
			const param = {
				tblKorNmString: this.tblKorNmString
			}
			const list = await api.selectMultiStblSearchList(param)
			const listData = list.data

			console.log(listData)

			this.searchStaticDetailList = listData
			this.searchStaticDetailCnt = listData.length

			if (gubun) {
				this.searchGubun = gubun
			}
		},

		// 통계표 검색 닫기
		closeSearch () {
			this.searchGubun = false
			this.tblKorNmString = ''
		},

		// 항목선택 - 선택 통계표 클릭 시
		async selectCellList (tblMgmNo, idx) {
			// 항목선택 탭에서만 동작
			if (this.commonTabs === 1) {
				this.selectedCellStatic = tblMgmNo

				let selectedIdx

				// 선택된 통계표 찾기
				$.each(this.selectedStaticList, function (idx, obj) {
					if (obj.tblMgmNo === tblMgmNo) {
						selectedIdx = idx
					}
				})

				// console.log('selectedIdx : ' + selectedIdx + ', tblMgmNo : '+ tblMgmNo)

				// 기존 표두, 표측 항목 목록 초기화 후 다시 세팅
				// this.cellheaderList = []
				// this.cellLeftList = []

				// if(this.selectedStaticList[selectedIdx].cellheaderList.length > 0){
				//     this.cellheaderList = this.selectedStaticList[selectedIdx].cellheaderList
				// }
				// if(this.selectedStaticList[selectedIdx].cellLeftList.length > 0){
				//     this.cellLeftList = this.selectedStaticList[selectedIdx].cellLeftList
				// }

				// 표두 항목 조회
				const statParam = {
					tblMgmNo: tblMgmNo,
					dsgnItemCd: 'CODE-1017906',
					multiGubun: 'Y'
				}
				const statHeaderList = await staticApi.selectStblDsgnDtlList(statParam)
				const statHeader = statHeaderList.data

				// 선택된 통계표에 표두 항목 추가
				this.$set(this.selectedStaticList[selectedIdx], 'statHeader', statHeader)

				// 표측 항목 조회
				const statLeftParam = {
					tblMgmNo: tblMgmNo,
					dsgnItemCd: 'CODE-1017907',
					multiGubun: 'Y'
				}
				const statLeftList = await staticApi.selectStblDsgnDtlList(statLeftParam)
				const statLeft = statLeftList.data

				// 선택된 통계표에 표측 항목 추가
				this.$set(this.selectedStaticList[selectedIdx], 'statLeft', statLeft)
			}
		},

		// 표두 항목 선택 이벤트
		selectCellHeader (nodeKey, index, pathNm, pathNodeKey) {
			let selectedIdx
			const selectedCellStatic = this.selectedCellStatic

			// 선택된 통계표 찾기
			$.each(this.selectedStaticList, function (idx, obj) {
				if (obj.tblMgmNo === selectedCellStatic) {
					selectedIdx = idx
				}
			})

			// console.log(this.selectedStaticList[selectedIdx])

			// const headerList = this.selectedStaticList[selectedIdx].cellheaderList
			const headerList = this.selectedStaticList[selectedIdx].selectedCellHeaderList

			let dupGubun = true

			headerList.forEach((obj, idx) => {
				if (obj.pathNodeKey === pathNodeKey) {
					headerList.splice(idx, 1)
					dupGubun = false
				}
			})

			if (dupGubun) {
				const tempObj = {}
				tempObj.index = index
				tempObj.pathNm = pathNm
				tempObj.nodeKey = nodeKey
				tempObj.pathNodeKey = pathNodeKey
				// this.cellheaderList.push(tempObj)
				headerList.push(tempObj)
			}

			// 선택된 통계표에 선택한 표두 항목 목록에 추가
			// this.$set(this.selectedStaticList[selectedIdx], 'cellheaderList', this.cellheaderList)
			this.$set(this.selectedStaticList[selectedIdx], 'cellheaderList', headerList)

			const selectedCellHeaderList = this.selectedStaticList[selectedIdx].cellheaderList

			// 선택한 표두 항목 목록 index 순서로 정렬하기
			selectedCellHeaderList.sort(function (comp1, comp2) {
				var comp1UC = comp1.index
				var comp2UC = comp2.index
				if (comp1UC < comp2UC) {
					return -1
				} else if (comp1UC > comp2UC) {
					return 1
				}
				return 0
			})

			// 선택 표두 항목 목록에 최종 추가
			this.$set(this.selectedStaticList[selectedIdx], 'selectedCellHeaderList', selectedCellHeaderList)
			// console.log(this.selectedStaticList[selectedIdx])
		},

		// 표측 항목 선택 이벤트
		selectCellLeft (nodeKey, index, pathNm, pathNodeKey) {
			let selectedIdx
			const selectedCellStatic = this.selectedCellStatic

			// 선택된 통계표 찾기
			$.each(this.selectedStaticList, function (idx, obj) {
				if (obj.tblMgmNo === selectedCellStatic) {
					selectedIdx = idx
				}
			})

			const leftList = this.selectedStaticList[selectedIdx].cellLeftList

			let dupGubun = true

			leftList.forEach((obj, idx) => {
				if (obj.pathNodeKey === pathNodeKey) {
					leftList.splice(idx, 1)
					dupGubun = false
				}
			})

			if (dupGubun) {
				const tempObj = {}
				tempObj.index = index
				tempObj.pathNm = pathNm
				tempObj.nodeKey = nodeKey
				tempObj.pathNodeKey = pathNodeKey
				// this.cellLeftList.push(tempObj)
				leftList.push(tempObj)
			}

			// 선택된 통계표에 선택한 표두 항목 목록에 추가
			// this.$set(this.selectedStaticList[selectedIdx], 'cellLeftList', this.cellLeftList)
			this.$set(this.selectedStaticList[selectedIdx], 'cellLeftList', leftList)

			const selectedCellLeftList = this.selectedStaticList[selectedIdx].cellLeftList

			// 선택한 표두 항목 목록 index 순서로 정렬하기
			selectedCellLeftList.sort(function (comp1, comp2) {
				var comp1UC = comp1.index
				var comp2UC = comp2.index
				if (comp1UC < comp2UC) {
					return -1
				} else if (comp1UC > comp2UC) {
					return 1
				}
				return 0
			})

			// 선택 표두 항목 목록에 최종 추가
			this.$set(this.selectedStaticList[selectedIdx], 'selectedCellLeftList', selectedCellLeftList)
		},

		// 선택 표두 항목 목록 만드는 이벤트
		async saveCellHeader (selectGubun, tblMgmNo) {
			let selectedIdx

			$.each(this.selectedStaticList, function (idx, obj) {
				if (obj.tblMgmNo === tblMgmNo) {
					selectedIdx = idx
				}
			})

			if (selectGubun === 'all_plus') {
				const cellheaderList = []

				this.selectedStaticList[selectedIdx].statHeader.forEach((obj, idx) => {
					const tempObj = {}
					tempObj.index = idx
					tempObj.pathNm = obj.pathNm
					tempObj.nodeKey = obj.nodeKey
					tempObj.pathNodeKey = obj.pathNodeKey
					cellheaderList.push(tempObj)

					$('#' + obj.tblMgmNo + '_header_' + idx).prop('checked', true)
				})

				// 선택된 통계표에 선택한 표두 항목 목록에 추가
				this.$set(this.selectedStaticList[selectedIdx], 'cellheaderList', cellheaderList)

				const selectedCellHeaderList = this.selectedStaticList[selectedIdx].cellheaderList

				// 선택한 표두 항목 목록 index 순서로 정렬하기
				selectedCellHeaderList.sort(function (comp1, comp2) {
					var comp1UC = comp1.index
					var comp2UC = comp2.index
					if (comp1UC < comp2UC) {
						return -1
					} else if (comp1UC > comp2UC) {
						return 1
					}
					return 0
				})

				// 선택 표두 항목 목록에 최종 추가
				this.$set(this.selectedStaticList[selectedIdx], 'selectedCellHeaderList', selectedCellHeaderList)
			} else if (selectGubun === 'all_minus') {
				const cellheaderList = []

				this.selectedStaticList[selectedIdx].statHeader.forEach((obj, idx) => {
					$('#' + obj.tblMgmNo + '_header_' + idx).prop('checked', false)
				})

				// 선택된 통계표에 선택한 표두 항목 목록에 추가
				this.$set(this.selectedStaticList[selectedIdx], 'cellheaderList', cellheaderList)

				const selectedCellHeaderList = this.selectedStaticList[selectedIdx].cellheaderList

				// 선택 표두 항목 목록에 최종 추가
				this.$set(this.selectedStaticList[selectedIdx], 'selectedCellHeaderList', selectedCellHeaderList)
			}
		},

		// 선택 표측 항목 목록 만드는 이벤트
		async saveCellLeft (selectGubun, tblMgmNo) {
			let selectedIdx

			$.each(this.selectedStaticList, function (idx, obj) {
				if (obj.tblMgmNo === tblMgmNo) {
					selectedIdx = idx
				}
			})

			if (selectGubun === 'all_plus') {
				this.cellLeftList = []

				this.selectedStaticList[selectedIdx].statLeft.forEach((obj, idx) => {
					const tempObj = {}
					tempObj.index = idx
					tempObj.pathNm = obj.pathNm
					tempObj.nodeKey = obj.nodeKey
					tempObj.pathNodeKey = obj.pathNodeKey
					this.cellLeftList.push(tempObj)

					$('#' + obj.tblMgmNo + '_left_' + idx).prop('checked', true)
				})

				// 선택된 통계표에 선택한 표두 항목 목록에 추가
				this.$set(this.selectedStaticList[selectedIdx], 'cellLeftList', this.cellLeftList)

				const selectedCellLeftList = this.selectedStaticList[selectedIdx].cellLeftList

				// 선택한 표두 항목 목록 index 순서로 정렬하기
				selectedCellLeftList.sort(function (comp1, comp2) {
					var comp1UC = comp1.index
					var comp2UC = comp2.index
					if (comp1UC < comp2UC) {
						return -1
					} else if (comp1UC > comp2UC) {
						return 1
					}
					return 0
				})

				// 선택 표두 항목 목록에 최종 추가
				this.$set(this.selectedStaticList[selectedIdx], 'selectedCellLeftList', selectedCellLeftList)
			} else if (selectGubun === 'all_minus') {
				this.cellLeftList = []

				this.selectedStaticList[selectedIdx].statLeft.forEach((obj, idx) => {
					$('#' + obj.tblMgmNo + '_left_' + idx).prop('checked', false)
				})

				// 선택된 통계표에 선택한 표두 항목 목록에 추가
				this.$set(this.selectedStaticList[selectedIdx], 'cellLeftList', this.cellLeftList)

				const selectedCellLeftList = this.selectedStaticList[selectedIdx].cellLeftList

				// 선택 표두 항목 목록에 최종 추가
				this.$set(this.selectedStaticList[selectedIdx], 'selectedCellLeftList', selectedCellLeftList)
			}
		},

		// 연도 선택 이벤트 - 전체
		checkedAllYearList (checked) {
			// console.log(checked)
			this.allChecked = checked
			for (const i in this.tblYearList) {
				this.tblYearList[i].selected = this.allChecked
			}
		},

		// 연도 선택 이벤트
		selectedYearList () {
			for (const i in this.tblYearList) {
				if (!this.tblYearList[i].selected) {
					this.allChecked = false
					return
				} else {
					this.allChecked = true
				}
			}
		},

		// 통계표 조회
		async selectMultiStblList () {
			const tblYear = []
			for (const i in this.tblYearList) {
				if (this.tblYearList[i].selected) {
					tblYear.push(this.tblYearList[i].tblYearMonth)
				}
			}

			// console.log(tblYear.length)

			if (tblYear.length === 0) {
				alert('연도를 선택해주세요.')
			} else {
				$('.hideStaticsBtn').removeClass('close')
				this.btnOpClImg = require('../../assets/img/ico_select_arrow2.png')
				$('.hideStatics').show()

				const headerStr = []
				const leftStr = []
				const tblMgmNoArr = []

				this.commonTabs = 3

				this.selectedStaticList.forEach((item, index) => {
					let tmpHeaderString = ''
					let tmpLeftString = ''

					tblMgmNoArr.push(item.tblMgmNo)

					item.selectedCellHeaderList.forEach((data, i) => {
						if (i == 0) tmpHeaderString += data.nodeKey.replace('ROOT>>', '')
						else tmpHeaderString += '@' + data.nodeKey.replace('ROOT>>', '')
					})

					item.selectedCellLeftList.forEach((data, i) => {
						if (i == 0) tmpLeftString += data.nodeKey.replace('ROOT>>', '')
						else tmpLeftString += '@' + data.nodeKey.replace('ROOT>>', '')
					})

					headerStr.push(tmpHeaderString)
					leftStr.push(tmpLeftString)
				})

				const frm = new FormData()

				frm.append('tblYear', tblYear)
				frm.append('headerStr', headerStr)
				frm.append('leftStr', leftStr)
				frm.append('tblMgmNoArr', tblMgmNoArr)

				const statisticsData = await api.selectMultiStblList(frm)
				const statisticsDataList = statisticsData.data

				// console.log(statisticsDataList)

				// this.commonTabs = 3

				// 그리드 데이터 세팅
				const groupedData = {}

				// console.log(statisticsDataList)

				statisticsDataList.forEach(item => {
					const key = `${item.tblMgmNo}-${item.tblKorNm}-${item.cellHead1}-${item.cellHead2}-${item.cellHead3}-${item.cellLeft1}-${item.cellLeft2}-${item.cellLeft3}`
					if (!groupedData[key]) {
						groupedData[key] = {
							tblMgmNo: item.tblMgmNo,
							tblKorNm: item.tblKorNm,
							cellHead1: item.cellHead1,
							cellHead2: item.cellHead2,
							cellHead3: item.cellHead3,
							cellLeft1: item.cellLeft1,
							cellLeft2: item.cellLeft2,
							cellLeft3: item.cellLeft3
						}
					}
					groupedData[key][`${item.tblYearMonth}`] = item.cellItmNumeric
				})

				this.rowData = Object.values(groupedData)

				// console.log(this.rowData)

				let headCnt1 = 0; let headCnt2 = 0; let headCnt3 = 0; let leftCnt1 = 0; let leftCnt2 = 0; let leftCnt3 = 0
				// let headHide1, headHide2, headHide3, leftHide1, leftHide2, leftHide3

				// 헤더 숨김 처리
				this.rowData.forEach((item, idx) => {
					if (item.cellHead1 !== null) headCnt1++
					if (item.cellHead2 !== null) headCnt2++
					if (item.cellHead3 !== null) headCnt3++
					if (item.cellLeft1 !== null) leftCnt1++
					if (item.cellLeft2 !== null) leftCnt2++
					if (item.cellLeft3 !== null) leftCnt3++
				})

				if (headCnt1 === 0) this.headHide1 = true
				if (headCnt2 === 0) this.headHide2 = true
				if (headCnt3 === 0) this.headHide3 = true
				if (leftCnt1 === 0) this.leftHide1 = true
				if (leftCnt2 === 0) this.leftHide2 = true
				if (leftCnt3 === 0) this.leftHide3 = true

				// 그리드 헤더 세팅
				const columnDefs = [
					{ headerName: '통계표명', field: 'tblKorNm', pinned: 'left', cellRenderer: this.customValueGetter },
					{ headerName: '표두1', field: 'cellHead1', pinned: 'left', cellRenderer: this.customValueGetter, hide: this.headHide1 },
					{ headerName: '표두2', field: 'cellHead2', pinned: 'left', cellRenderer: this.customValueGetter, hide: this.headHide2 },
					{ headerName: '표두3', field: 'cellHead3', pinned: 'left', cellRenderer: this.customValueGetter, hide: this.headHide3 },
					{ headerName: '표측1', field: 'cellLeft1', pinned: 'left', cellRenderer: this.customValueGetter, hide: this.leftHide1 },
					{ headerName: '표측2', field: 'cellLeft2', pinned: 'left', cellRenderer: this.customValueGetter, hide: this.leftHide2 },
					{ headerName: '표측3', field: 'cellLeft3', pinned: 'left', cellRenderer: this.customValueGetter, hide: this.leftHide3 }
				]

				const headYearArry = []

				tblYear.forEach((item, index) => {
					const headObj = {}
					headObj.headerName = item
					headObj.field = item + '_value'
					headObj.type = 'numberType'
					headYearArry.push(headObj)
				})

				this.columnDefs = columnDefs.concat(headYearArry)

				const testCol = []
				testCol.tblYear = tblYear
				testCol.columnDefs = this.columnDefs
				// testCol.push(tblYear)
				this.gridColumn = testCol

				// console.log(this.gridColumn)

				this.gridYear = tblYear

				// console.log(this.columnDefs)
				// console.log(this.rowData)
			}
		},

		// 통계표 엑셀 다운로드
		gridDownload () {
			// console.log($(".multi-grid > thead > tr > th"))
			// let thead = $(".multi-grid > thead > tr > th")
			// console.log(thead.length)

			// let gridHeader = []
			// for(let i = 0 ; i < thead.length ; i ++){
			//     if(thead.eq(i).is(":visible")){
			//         // console.log(thead.eq(i).text())
			//         gridHeader.push(thead.eq(i).text())
			//     }
			// }

			const instance = document.getElementById('multiGrid')

			const config = { raw: true, type: 'string' }
			const ws = xlsx.utils.table_to_sheet(instance, config)
			const wb = xlsx.utils.book_new()

			xlsx.utils.book_append_sheet(wb, ws, 'Sheet1')
			xlsx.writeFile(wb, '복합통계표.xlsx')
		}

	}
}

</script>
<style scoped>
.lastDepth01 {
  width:calc(100%);
  border-right: 0;
}
.lastDepth02 {
  width:calc(100% - 255px);
  border-right: 0;
}
.lastDepth03 {
  width:calc(100% - 510px);
  border-right: 0;
}
.lastDepth04 {
  width:calc(100% - 765px);
  border-right: 0;
}
.lastDepth05 {
  width:calc(100% - 765px);
  border-right: 0;
}

.selSpan {
    cursor: pointer;
}
.selSpan.on {
    color: #5670bc;
    font-weight: bold;
}

.btn-open {
    background-image: url("../../assets/img/ico_select_arrow2.png");
}
.btn-close {
    background-image: url("../../assets/img/ico_select_arrow2_close.png");
}
</style>
